/* unplugin-vue-components disabled */import { render } from "./avatar.vue?vue&type=template&id=15711b09&scoped=true"
import script from "./avatar.vue?vue&type=script&lang=js"
export * from "./avatar.vue?vue&type=script&lang=js"

import "./avatar.vue?vue&type=style&index=0&id=15711b09&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15711b09"],['__file',"src/controls/avatar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "15711b09"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('15711b09', __exports__)) {
    api.reload('15711b09', __exports__)
  }
  
  module.hot.accept("./avatar.vue?vue&type=template&id=15711b09&scoped=true", () => {
    api.rerender('15711b09', render)
  })

}


export default __exports__